/**
 * Belege
 * Die Belege aus dem Belegbuch in ADNOVA+ können mittels dieser API bearbeitet, geheftet, entheftet sowie festgeschrieben und storniert werden. Des Weiteren können auch neue Belege importiert werden. Der Import läuft über eine Queue. Daher kann nach dem Aufruf der \"createBeleg\" - Schnittstelle über die Schnittstelle \"importstatus\", mittels der InhaltId, der Status abgefragt werden. Enthält der Importstatus eine BelegId ist der Beleg erfolgreich angelegt worden und kann über diese BelegId abgerufen werden. Damit der Beleg vollständig bearbeitet und ergänzt werden kann, lassen sich die nötigen Daten zu Vorgangsarten, Stichworte, Label, Ordner, Erläuterungen und FreitextPartner abrufen und bearbeiten. Das Heften und Entheften von Belegen ist ebenfalls möglich,. Beim Entheften ist darauf zu achten, dass die einzelnen Seiten wie neue Belege importiert werden. Daher müssen über den Importstatus die neuen BelegIds abgefragt werden, wenn der Beleg fertig entheftet ist. 
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BasePageableDTO } from './base-pageable-dto';
import { PageableBelegAllOfDTO } from './pageable-beleg-all-of-dto';


/**
 * Gibt das OffSet, Limit und die Sortierung für das Abrufen von Belegen an.<br> 
 */
export interface PageableBelegDTO { 
    /**
     * Wird bei GET-Funktionen genutzt, um anzugeben, wie viele Werte übersprungen werden sollen.
     */
    offset?: number;
    /**
     * Wird bei GET-Funktionen genutzt, um die Anzahl der zurückgegebenen Werte zu begrenzen
     */
    limit?: number;
    sorting?: Array<PageableBelegDTOSortingEnum>;
}
export enum PageableBelegDTOSortingEnum {
    Erstelltasc = 'ERSTELLTASC',
    Erstelltdesc = 'ERSTELLTDESC',
    Geaendertasc = 'GEAENDERTASC',
    Geaendertdesc = 'GEAENDERTDESC',
    Datumasc = 'DATUMASC',
    Datumdesc = 'DATUMDESC',
    Jahrasc = 'JAHRASC',
    Jahrdesc = 'JAHRDESC',
    Nummerasc = 'NUMMERASC',
    Nummerdesc = 'NUMMERDESC',
    Dateigroesseasc = 'DATEIGROESSEASC',
    Dateigroessedesc = 'DATEIGROESSEDESC',
    Betragasc = 'BETRAGASC',
    Betragdesc = 'BETRAGDESC',
    Zahlungsbetragasc = 'ZAHLUNGSBETRAGASC',
    Zahlungsbetragdesc = 'ZAHLUNGSBETRAGDESC',
    Vorgangsartasc = 'VORGANGSARTASC',
    Vorgangsartdesc = 'VORGANGSARTDESC',
    Partnerbezeichnungasc = 'PARTNERBEZEICHNUNGASC',
    Partnerbezeichnungdesc = 'PARTNERBEZEICHNUNGDESC',
    Erlaeuterungasc = 'ERLAEUTERUNGASC',
    Erlaeuterungdesc = 'ERLAEUTERUNGDESC',
    Ibanasc = 'IBANASC',
    Ibandesc = 'IBANDESC',
    Verwendungszweckasc = 'VERWENDUNGSZWECKASC',
    Verwendungszweckdesc = 'VERWENDUNGSZWECKDESC',
    Faelligkeitsdatumasc = 'FAELLIGKEITSDATUMASC',
    Faelligkeitsdatumdesc = 'FAELLIGKEITSDATUMDESC',
    Dauerbelegasc = 'DAUERBELEGASC',
    Dauerbelegdesc = 'DAUERBELEGDESC',
    Uploadbuchstelleasc = 'UPLOADBUCHSTELLEASC',
    Uploadbuchstelledesc = 'UPLOADBUCHSTELLEDESC',
    Belegbuchasc = 'BELEGBUCHASC',
    Belegbuchdesc = 'BELEGBUCHDESC',
    Statusasc = 'STATUSASC',
    Statusdesc = 'STATUSDESC',
    Kommentarasc = 'KOMMENTARASC',
    Kommentardesc = 'KOMMENTARDESC',
    Umsatzzugeordnetasc = 'UMSATZZUGEORDNETASC',
    Umsatzzugeordnetdesc = 'UMSATZZUGEORDNETDESC',
    Zahlungsartasc = 'ZAHLUNGSARTASC',
    Zahlungsartdesc = 'ZAHLUNGSARTDESC'
};



